import request from './request';

export function getAllPageViewsForDomain(domain) {
  return request({
    path: `/v1/visitors/pageviews/all?domain=${domain}`,
  });
}

export function getVisitorsForDomain(domain) {
  return request({
    path: `/v1/visitors/${domain}`,
  });
}

export function getPageViewsForPerson(personId) {
  return request({
    path: `/v1/visitors/pageviews/person?person_id=${personId}`,
  });
}

export function getAnonymousPageViewsForDomain(domain) {
  return request({
    path: `/v1/visitors/pageviews/anonymous?domain=${domain}`,
  });
}
